const mutations = {

  auth_success(state, { club, token, clubmenu, club_qrcode }) {
    state.status = "success",
      state.Clubtoken = token,
      state.club = club,
      state.clubmenu = clubmenu,
      state.loading = false;
    if (club_qrcode) {
      state.club_qrcode = club_qrcode.QrCode;
    }
  },

  auth_error(state) {
    state.status = "error",
      state.loading = false;
  },

  auth_request(state) {
    state.status = "loading";
    state.loading = true;
  },

  SET_PROFIL_DATA(state, { club }) {
    state.club = club;
  },
  REGISTER_CLUB() {

  },
  SET_CLUB_QRCODE(state, data) {
    state.club_qrcode = data;
  },

  SET_AUTO_BESTAETIGUNG_HOLEN(state, value) {
    if (state.club) {
      state.club = { ...state.club, auto_bestaetigung_holen: value };
    }
  },

  SET_TOKEN(state, token) {
    state.Clubtoken = token;
  },

  logout(state) {
    state.status = "",
      state.Clubtoken = "",
      state.club = null,
      state.clubmenu = null,
      state.club_qrcode = null;
    state.loading = false;
  }


};

export default mutations;
